(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vmmv", [], factory);
	else if(typeof exports === 'object')
		exports["vmmv"] = factory();
	else
		root["vmmv"] = factory();
})(this, function() {
return 